<div
	*ngIf="isRendered"
	class="filesContainer {{ styleClass }} fade row m-0 gx-0 align-items-center justify-content-center flex-column flex-nowrap p-2 p-md-3"
	[ngClass]="{
		'disabled': isDisabled || fileDropService?.fileProcessConditionals?.importInProgress,
		'show': !isHidden
	}"
	[ngbCollapse]="isHidden"
	appDragDropFiles
	[allowMultiFileDrop]="allowMultiFileDrop"
	[acceptedFileTypes]="acceptedFileTypes"
	[fileInput]="fileDropInput"
	(click)="fileDropInput.click()"
	(fileDropped)="onFilesChange($event)"
>
	<!-- Icon	-->
	<i class="col-auto mx-auto fa-4x icon-paper-clip"></i>

	<!-- Description Text	-->
	<p
		*ngIf="description"
		class="col-12 mb-0 mx-auto mt-2 text-center wordBreak--breakWord"
	>
		{{ description }}
	</p>

	<!-- Info Text	-->
	<p
		*ngIf="infoText"
		class="col-12 mb-0 mx-auto text-center infoText--text"
	>
		{{ infoText }}
	</p>

	<!-- Projected Content -->
	<ng-content></ng-content>

	<!-- Hidden FileInput	-->
	<input
		#fileDropInput
		type="file"
		hidden
		[accept]="acceptedFileTypes"
		[multiple]="allowMultiFileDrop"
		(change)="onFilesChange($event.target.files)"
	>
</div>
